import { Icon, type IconProps } from "@chakra-ui/react"
import Logo from '@/assets/icons/KreozaMark.svg';

export const KreozaMark = ({
  color = "currentColor",
  bg,
  boxSize = "lg",
  ...props
}: IconProps & { bg?: string }) => {
  return (
    <Icon boxSize={boxSize} color={color} bg={bg} {...props}>
      <Logo />
    </Icon>
  );
};
